import type { QuotaCleanerItem } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import { UserQuotaGroupType } from 'reactApp/types/QuotaCleaner';

export const isDownloadByUrl = (item: QuotaCleanerItem) => item.groupType === UserQuotaGroupType.Letter;
